import React, { FC } from 'react';
import { Button, Modal } from 'antd';
import { IconBackground } from 'common/components';
import { InfoRed } from 'common/svg';
import { EColor } from 'common/const';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

export const RemoveUserSubdivisionModal: FC<IComponentProps> = ({ open, loading, onCancel, onSubmit }) => {
  const handleCancel = (): void => {
    if (loading) {
      return;
    }

    onCancel();
  };

  return (
    <Modal
      rootClassName="redesign modal"
      width={454}
      centered
      open={open}
      onCancel={handleCancel}
      destroyOnClose
      closeIcon={false}
      styles={{ mask: { background: 'transparent' } }}
      footer={[
        <Button key="cancel" className="button-sm secondary" loading={loading} onClick={handleCancel}>
          Отмена
        </Button>,
        <Button key="submit" className="button-sm primary" loading={loading} onClick={onSubmit}>
          Отвязать
        </Button>,
      ]}
    >
      <div className="mb-7">
        <IconBackground content={<InfoRed className="icon-info-red" />} color={EColor.PaleRed} />
      </div>

      <div className="mb-4 ff-medium fs-m">Вы уверены, что хотите отвязать пользователя от подразделения?</div>

      <div className="mb-6 ff-regular fs-s color-dark-grey">
        Пользователь больше не сможет создавать заявки и оформлять заказы от имени этого подразделения.
      </div>
    </Modal>
  );
};
